module.exports = __webpack_public_path__ + "img/hud-04.1dde9a38.png";